import { gql } from "@apollo/client"
import { LOCATION_FIELDS } from "../locations"

const LOGIN_FIELDS = gql`
  ${LOCATION_FIELDS}
  fragment LoginFields on LoginResult {
    ticket {
      token
      expiry
      username
      external
      firstName
      lastName
      email
      avatar
      userID
      createdAt
      roles
      groups
      permissions {
        key
        value
      }
    }
    settings {
      searches {
        at
        text
      }
      organisation {
        id
        name
        logo
        disabled
      }
      fl
      location
      locations {
        ...LocationFields
      }
      features {
        key
        value
      }
      deviceGroups
      deviceTimer
    }
  }
`

const queryLoginWithUsernameAndPassword = async (credentials, client) => {
  const { username, password } = credentials
  try {
    const response = await client.query({
      query: gql`
        ${LOGIN_FIELDS}
        query LoginWithUsernameAndPassword($username: String!, $password: String!) {
          login(username: $username, password: $password) {
            ...LoginFields
          }
        }
      `,
      fetchPolicy: "network-only",
      variables: {
        username,
        password,
      },
    })
    return response
  } catch (err) {
    return err
  }
}

const queryLoginWithExternal = async ({ identityProvider, idToken }, client) => {
  try {
    const response = await client.query({
      query: gql`
        ${LOGIN_FIELDS}
        query LoginWithExternal($identityProvider: ID!, $idToken: String!) {
          loginWithExternal(identityProvider: $identityProvider, idToken: $idToken) {
            ...LoginFields
          }
        }
      `,
      fetchPolicy: "network-only",
      variables: {
        identityProvider,
        idToken,
      },
    })
    return response
  } catch (err) {
    return err
  }
}

const queryLoginWithGoogle = async ({ idToken, client: clientType }, client) => {
  try {
    const response = await client.query({
      query: gql`
        ${LOGIN_FIELDS}
        query LoginWithGoogle($idToken: String!, $client: GoogleLoginClient!) {
          loginWithGoogle(idToken: $idToken, client: $client) {
            ...LoginFields
          }
        }
      `,
      fetchPolicy: "network-only",
      variables: {
        idToken,
        client: clientType,
      },
    })
    return response
  } catch (err) {
    return err
  }
}

const queryLoginWithMicrosoft = async ({ idToken }, client) => {
  try {
    const response = await client.query({
      query: gql`
        ${LOGIN_FIELDS}
        query LoginWithMicrosoft($idToken: String!) {
          loginWithMicrosoft(idToken: $idToken) {
            ...LoginFields
          }
        }
      `,
      fetchPolicy: "network-only",
      variables: {
        idToken,
      },
    })
    return response
  } catch (err) {
    return err
  }
}

export {
  queryLoginWithUsernameAndPassword,
  queryLoginWithExternal,
  queryLoginWithGoogle,
  queryLoginWithMicrosoft,
  LOGIN_FIELDS,
}
